export default {
    //install: (app) => {
    install: () => {
        //app.use()
    }
}
